import * as axios from 'axios';
import _ from 'lodash';
import { t } from '../../locales';

export const SET_ERROR = '/app/set_error';
export const PRINT = '/app/print';
export const CLEAR_CACHE = '/app/clear_cache';
export const SET_LOGGING_IN = '/app/set_logging_in';
export const SET_LOGIN_ERROR = '/app/set_login_error';
export const SET_LANGUAGE= '/app/set_language';
export const LOAD_AUTH_TOKEN = '/app/load_auth_data';
export const LOAD_LOCATIONS = '/app/load_locations';
export const LOAD_DURATIONS = '/app/load_durations';
export const LOAD_LOCATION = '/app/load_location';
export const LOAD_PRINTER_MAC = '/app/load_printer_token';
export const LOAD_BUSINESS_INFO = '/app/load_business_info';
export const LOAD_INTAKE_FORMS = '/app/load_intake_forms';
export const LOAD_CUSTOM_FIELDS = '/app/load_custom_fields';

export function setError(message) {
  return { type: SET_ERROR, data: message };
}

export function clearError() {
  return { type: SET_ERROR, data: null };
}

export function setAuthToken(data) {
  return { type: LOAD_AUTH_TOKEN, data: data };
}

export function setLanguage(data) {
  return { type: SET_LANGUAGE, data: data };
}

export function setBusinessInfo(data) {
  return { type: LOAD_BUSINESS_INFO, data: data };
}

export function setLocations(data) {
  return { type: LOAD_LOCATIONS, data: data };
}

export function setDurations(data) {
  return { type: LOAD_DURATIONS, data: data };
}

export function setLocation(data) {
  return { type: LOAD_LOCATION, data: data };
}

export function setPrinterMac(data) {
  return { type: LOAD_PRINTER_MAC, data: data };
}

// log in the user with email and password
// if successful then get business data and locations and finally return true
// if not sucessfull return false
export function login(email, password, recaptchaToken) {
  var formData = new FormData();
  formData.set('email', email);
  formData.set('password', password);
  formData.set('g-recaptcha-response', recaptchaToken);

  return function(dispatch) {
    dispatch({ type: SET_LOGGING_IN, data: true });

    return axios
      .post('/api/users/sign_in', formData)
      .then(res => {
        const authToken = res.data.auth_token;
        axios.defaults.params = {};
        axios.defaults.params['auth_token'] = authToken;

        return Promise.all([
          dispatch(getBusinessInfo()),
          dispatch(getLocations()),
        ]).then(() => {
          dispatch(setAuthToken(authToken));
          return Promise.resolve(true);
        });
      })
      .catch(error => {
        // alert(error)
        console.log('err', error, error.request, error.response, error.data);
        const message = _.get(error, 'response.data.message');

        dispatch({
          type: SET_LOGIN_ERROR,
          data: message
            ? message
            : t('app_action.error_logging_in_please_try_again'),
        });
        return Promise.resolve(false);
      });
  };
}

export function print(serviceNumber, printerMac) {
  return function(dispatch) {
    dispatch({ type: PRINT, data: true });
    var formData = new FormData();
    formData.set('job[content]', serviceNumber);
    formData.set('job[printer_id]', printerMac);

    const printAxios = axios.create({
      baseURL: 'https://star-tsp650.mytime.com',
      timeout: 1000,
    });
    printAxios.defaults.params = {};
    return printAxios.post('/jobs', formData);
  };
}

export function clearCache() {
  return function(dispatch) {
    dispatch({ type: CLEAR_CACHE, data: true });
    localStorage.removeItem('authToken');
    localStorage.removeItem('location');
    localStorage.removeItem('printerMac');
  };
}

export function getBusinessInfo() {
  return function(dispatch) {
    return axios
      .get('/business_info_globals')
      .then(res => {
        dispatch(setBusinessInfo(res.data));
        return Promise.resolve(true);
      })
      .catch(error => {
        dispatch(clearCache());
        window.location.reload();
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
      });
  };
}

export function getLocations() {
  return function(dispatch) {
    return axios
      .get('/my_client/v2/locations.json')
      .then(res => {
        const locations = res.data.locations;

        dispatch(setLocations(locations));
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
      });
  };
}

export function getDurations(location) {
  return function(dispatch) {
    return axios
      .get(`/my_client/durations.json?location_ids=${location?.id}`)
      .then(res => {
        const durations = res.data.durations;

        dispatch(setDurations(durations));
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
      });
  };
}

export function getIntakeForms() {
  return function(dispatch) {
    return axios
      .get(
        '/my_client/intake_forms.json?intake_form_items=true&intake_form_variations=true'
      )
      .then(res => {
        dispatch({
          type: LOAD_INTAKE_FORMS,
          data: res.data,
        });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
      });
  };
}

export function getCustomFields() {
  return function(dispatch) {
    return axios
      .get(
        '/my_client/custom_fields.json?custom_field_option_groups=true&custom_field_dependencies=true'
      )
      .then(res => {
        dispatch({
          type: LOAD_CUSTOM_FIELDS,
          data: res.data,
        });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
      });
  };
}
